import { onScreen } from 'Lib/on-screen/on-screen';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';
import { Popup } from 'Lib/popup/popup';
import { PopupVideo } from 'Lib/popup/popup-video';

const popupVideo = new PopupVideo();
const sPic = '.video-reviews__pic';
const elPic = document.querySelectorAll(sPic);
const pagenavAjax = new Set([...elPic].map((el) => el.closest('.pagenav-ajax')));
const elsPicsStackLoad = new Set();

function setLoadPicListener(els) {
    [...els].forEach((el) => {
        if (!elsPicsStackLoad.has(el)) {
            elsPicsStackLoad.add(el);
            onScreen($(el), loadSrcOrBg);
        }
    });
}

function setModalsVideoReviews() {
    document.querySelectorAll('.video-reviews__item')?.forEach((item) => {
        const elPopup = item.querySelector('.popup');
        const popup = new Popup('popup', elPopup);

        item.addEventListener('click', (e) => {
            if (!e.currentTarget.classList.contains('js-popup-video')) {
                const evtTarget = e.target;

                if (!evtTarget.closest('.video-reviews__reactions-box')
                    && !evtTarget.classList.contains('popup') && !evtTarget.classList.contains('popup__close-box') && !evtTarget.classList.contains('popup__close')) {
                    popup.open();

                    // Виджеты инсты и тиктока спустя пару открытий модалки перестают устанавливать себе высоту,
                    // а нужно каждый раз удалять код виджетов для остановки запущенного видео при закрытии модалки,
                    // поэтому растягиваем их на всю высоту модалки, если её открывают повторно
                    setTimeout(() => {
                        elPopup.querySelector('iframe').style.minHeight = `100%`;
                    });
                }
            }
        });
    });
}

popupVideo.popupVideoOpenDefault();
setLoadPicListener(elPic);

$('body').on('bitrixDynamicComposite.eksmo', () => {
    setModalsVideoReviews();
    popupVideo.popupVideoOpenDefault();
    setLoadPicListener(document.querySelectorAll(sPic));
});

pagenavAjax.forEach((el) => {
    $(el).on('eksmoPagenavAjax', (e) => {
        setLoadPicListener(e.target.querySelectorAll(sPic));
        setModalsVideoReviews();
        popupVideo.popupVideoOpenDefault();
    });
});